const imgUrl = [
  require('../../../assets/img/solutions/z智能监护.png'),
  require('../../../assets/img/solutions/monitor/shujuchanping.png'),
  require('../../../assets/img/solutions/monitor/Social-channels.png'),
];

export default imgUrl;
